import React, { FunctionComponent } from "react";
import ProgressBar from '../ProgressBar/ProgressBar'
import Question from '../QuestionComponents/Question'
import AnteriorSiguienteButtons from '../AnteriorSiguienteButtons/AnteriorSiguienteButtons'
import HeaderImage from './Header'

interface ContainerProps {
    headerImage: string,
    progress: number,
    data: any,
    linkAnterior: string,
    linkSiguiente: string
}

const GenericStep: FunctionComponent<ContainerProps> = (props) => {
    const headerImage = props.headerImage
    const progress = props.progress
    const data = props.data
    const anterior = props.linkAnterior
    const siguiente = props.linkSiguiente

    return (
        <div className="body container-fluid">
            <HeaderImage image={headerImage}></HeaderImage>

            {data.map( (q: any, index: number) =>
                <Question question={q} key={`${index}_${q.title}`} ></Question>
            )}

            <ProgressBar progress={progress}></ProgressBar>
            <AnteriorSiguienteButtons linkAnterior={anterior} linkSiguiente={siguiente}></AnteriorSiguienteButtons>
        </div>
    )
}
export default GenericStep;